var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"0d2a34267afc2fab9d3af729602907a509ac5c27"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

/* global process */
import { CaptureConsole as CaptureConsoleIntegration } from "@sentry/integrations";
import * as Sentry from "@sentry/nextjs";
import { Replay } from "@sentry/replay";

const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;
const RELEASE_TAG = process.env.NEXT_PUBLIC_RELEASE_TAG;
const ENVIRONMENT = process.env.NEXT_PUBLIC_ENVIRONMENT;

if (ENVIRONMENT !== "local") {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT,
    integrations: [
      new Sentry.BrowserTracing(),
      new CaptureConsoleIntegration({
        levels: ["error"],
      }),
      new Replay({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    denyUrls: ["http://localhost:"],
    release: RELEASE_TAG,
    ignoreErrors: [
      "Abort fetching component for route:",
      "Route did not complete loading:",
      "504 Gateway Time-out",
      "502 Bad Gateway",
      "Unexpected token '<'",
      "Invariant: attempted to hard navigate to the same URL",
      "The user aborted a request",
    ],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}
